import { isObject } from '@asset-metrix/portal-ui';

/**
 * We use a custom pointer format, that is not entirely supported by ag-grid.
 * ag-grid supports nested pointers like `parent.child` natively, but we also allow that pointer to retrieve an array
 * of values. Therefore we need to write our custom extraction logic.
 */
export const extractValue = (
  pointer: string,
  data: unknown,
  strict = false
) => {
  const fieldFragments = pointer.split('.');

  let dataIterator = data;

  for (const fragment of fieldFragments) {
    const value = Array.isArray(dataIterator)
      ? dataIterator.map((d) => d[fragment]).filter((d) => d != null)
      : isObject(dataIterator)
        ? dataIterator[fragment]
        : undefined;

    if (value == null || (Array.isArray(value) && value.length === 0)) {
      // Data could not be found
      dataIterator = strict ? value : null;
      break;
    }

    dataIterator = Array.isArray(value) ? value.flat() : value;
  }

  return dataIterator;
};
